import React, { Component } from 'react'
import Search from './Search'
import Calendar from './Calendar'
import EditSchedule from './EditSchedule'
import store from './store'
import myStore from './Search/store'
import { HeaderView } from '@merchant-backend/common-components'
import { Button } from 'hljd'
import editScheduleStore from './EditSchedule/store'

export default class extends Component {
  componentDidMount() {
    store.getHotelHalls()
    store.getMerchantInfo()
    myStore.search()
  }

  render() {
    return (
      <HeaderView
        title="日历模式"
        extra={
          <Button type="primary" onClick={editScheduleStore.addSchedule}>
            新建档期
          </Button>
        }
      >
        <Search />
        <Calendar />
        <EditSchedule />
      </HeaderView>
    )
  }
}
